import Loader from 'components/shared/Loader'
import { useApp } from 'store/steps'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { useListVouchersQuery } from 'store/api-slice/hooks'
import ValueVoucherConfiguration from './ValueVoucherConfiguration'
import CardVoucherConfiguration from './CardVoucherConfiguration'
import { useEffect, useMemo } from 'react'
import { setVouchersProducts } from 'store/vouchers-slice'
import Section from 'components/shared/Section'

const VouchersConfigurationsList = () => {
    const dispatch = useAppDispatch()
    const { language } = useApp()

    const { vouchersType, quantity, vouchersBoxes } = useAppSelector(
        (state) => state.vouchers
    )

    const { data: productsData, isFetching: isProductsDataFetching } =
        useListVouchersQuery({
            _locale: language,
        })

    const configuratorsToDisplay = useMemo(() => {
        if (vouchersType === 'amount')
            return vouchersBoxes.map(({ cartItemId }, index) => (
                <ValueVoucherConfiguration
                    index={index}
                    isEraseable={quantity > 1}
                    key={cartItemId}
                />
            ))
        if (vouchersType === 'product')
            return vouchersBoxes.map(({ cartItemId }, index) => (
                <CardVoucherConfiguration
                    key={cartItemId}
                    isEraseable={quantity > 1}
                    index={index}
                />
            ))
    }, [vouchersType, vouchersBoxes])

    useEffect(() => {
        const { products } = productsData || {}

        if (!products) return

        dispatch(setVouchersProducts(products))
    }, [productsData])

    return (
        <>
            {isProductsDataFetching && (
                <Section>
                    <Loader />
                </Section>
            )}

            {!isProductsDataFetching && configuratorsToDisplay}
        </>
    )
}

export default VouchersConfigurationsList
